import React from 'react'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import TreatmentDate from './TreatmentDate'
import HealthcareTeam from './HealthcareTeam'
import TeamAddress from './TeamAddress'
import { injectIntl } from 'react-intl'
// import { caseSelector } from '../../../../redux/selectors'
import { caseSelector } from '../redux/selectors'
import { compose } from 'recompose'
import { connect } from 'react-redux'

const CaseInformation = ({data, intl}) =>{
    return(
        <Grid 
            data-testid='case-info'
            container direction="column" style={{padding: '12px 2rem 0', width:'30rem'}}>
            <Grid item style={{paddingBottom: '12px'}}>
                <Typography style={{fontWeight: '700'}}>
                    {intl.formatMessage({id: 'app.dashboard.caseInformation'})}
                </Typography>
            </Grid>
            {data && data.treatmentDate && 
                <TreatmentDate data-testid='case-info-treatment-date' date={data.treatmentDate} />}
            {data && 
                <HealthcareTeam data-testid='case-info-healthcare-tem' data={data} />}
            {data && 
                <TeamAddress data-testid='case-info-team-address' data={data}/>}
        </Grid>
    )
}

const mapStateToProps = (state, ownProps) => ({
    data: caseSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)

export default enhance(CaseInformation)